export default __webpack_public_path__ + "static/media/explore_icon.4b047ee1.svg";